export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_4.2-44b1c01f2c6417e7e756b2a339215d07.svg";